export default __webpack_public_path__ + "static/media/attendancerules-icon.8c8e3812.svg";